import { useMemo, useState } from 'react'
import { INVOICES_TABLE } from '@/components/Settings/settingsTablePlaceholders'

export function useInvoiceDetailsModel() {
  const [invoiceQuery, setInvoiceQuery] = useState('')
  const filteredInvoices = useMemo(() => {
    const q = invoiceQuery.trim().toLowerCase()
    if (!q) return INVOICES_TABLE
    return INVOICES_TABLE.filter((row) =>
      [row.invoiceId, row.billingDate, row.plan, row.amount, row.status.label].some((field) =>
        String(field).toLowerCase().includes(q),
      ),
    )
  }, [invoiceQuery])
  return { invoiceQuery, setInvoiceQuery, filteredInvoices }
}
